import { render, staticRenderFns } from "./FaqBanner.vue?vue&type=template&id=a596ad46&scoped=true&"
import script from "./FaqBanner.vue?vue&type=script&lang=js&"
export * from "./FaqBanner.vue?vue&type=script&lang=js&"
import style0 from "./FaqBanner.vue?vue&type=style&index=0&id=a596ad46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a596ad46",
  null
  
)

export default component.exports